import { render, staticRenderFns } from "./addedit-officers.vue?vue&type=template&id=2fffb938"
import script from "./addedit-officers.vue?vue&type=script&lang=js"
export * from "./addedit-officers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports